<template>
  <CasinoApp />
</template>

<script>
import CasinoApp from './components/CasinoApp';
import store from './store'
export default {
  name: 'App',
  store,
  components: {
    CasinoApp,
  },

  mounted() {
   if(window.location.href.includes('confronto')) {
     store.commit('setComparisonMode',true)
   }
  }
};
</script>
